import { useState, useEffect, useRef } from 'react';
import { CartItem } from '../types';
import { UseCartResult } from '../types';
import { CartService } from '../services/cartService';

export function useCart(enabled: boolean = true): UseCartResult {
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const fetchedRef = useRef(false);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    let isMounted = true;

    // Prevent duplicate fetches
    if (fetchedRef.current) {
      return;
    }
    fetchedRef.current = true;

    const fetchCart = async () => {
      try {
        if (isMounted) {
          setLoading(true);
          setError(null);
        }
        const fetchedCartItems = await CartService.getCart();
        if (isMounted) {
          setCartItems(fetchedCartItems);
        }
      } catch (err: unknown) {
        const errorMessage = err instanceof Error ? err.message : 'Failed to load cart';
        if (isMounted) {
          setError(errorMessage);
        }
        console.error('Error fetching cart:', err);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchCart();

    return () => {
      isMounted = false;
    };
  }, [enabled]);

  return {
    cartItems,
    loading,
    error,
  };
}
